/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiRiskRule } from './ApiRiskRule';
import {
    ApiRiskRuleFromJSON,
    ApiRiskRuleFromJSONTyped,
    ApiRiskRuleToJSON,
    ApiRiskRuleToJSONTyped,
} from './ApiRiskRule';

/**
 * 
 * @export
 * @interface RiskRulePage
 */
export interface RiskRulePage {
    /**
     * 
     * @type {number}
     * @memberof RiskRulePage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof RiskRulePage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof RiskRulePage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiRiskRule>}
     * @memberof RiskRulePage
     */
    content: Array<ApiRiskRule>;
}

/**
 * Check if a given object implements the RiskRulePage interface.
 */
export function instanceOfRiskRulePage(value: object): value is RiskRulePage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function RiskRulePageFromJSON(json: any): RiskRulePage {
    return RiskRulePageFromJSONTyped(json, false);
}

export function RiskRulePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskRulePage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiRiskRuleFromJSON)),
    };
}

export function RiskRulePageToJSON(json: any): RiskRulePage {
    return RiskRulePageToJSONTyped(json, false);
}

export function RiskRulePageToJSONTyped(value?: RiskRulePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiRiskRuleToJSON)),
    };
}

